import {
  getCodesFromLC,
  getDataFromServer,
  setCodesJSONToLC
} from '../../../util';
import {
  ClusterViewDescription_LC,
  FeatureCategoryCodes_LC
} from '../../../../util/GlobalConstant';

export class ClusterInformationModule {
  constructor(baseURL, httpHeaders) {
    this.baseURL = baseURL;
    this.httpHeaders = httpHeaders;
  }

  fetchClusterInformation = async (payload) => {
    const { clusterId, modelId, clusterIndicatorGroup, limit, offset } =
      payload;
    const url = `${this.baseURL}/customers/cluster/${clusterId}/riskIndicator`;
    return await getDataFromServer(url, this.httpHeaders, {
      modelId,
      clusterIndicatorGroup,
      limit,
      offset
    });
  };

  fetchClusterViewDescriptionCodes = async () => {
    let clusterViewDescData = [];
    clusterViewDescData = await getCodesFromLC(ClusterViewDescription_LC);
    if (clusterViewDescData.length === 0) {
      const params = {
        codeType: 'CLUSTER_VIEW_DESCRIPTION'
      };
      const response = await getDataFromServer(
        `${this.baseURL}/codes`,
        this.httpHeaders,
        params
      );
      await setCodesJSONToLC(ClusterViewDescription_LC, response);
      return response;
    }
    return clusterViewDescData;
  };
}
